export const IMAGES = {
  ROTATE_IMAGE: "/data/additional_images/ic_turn.png",
  BACK_TO_MAP_IMAGE: "/data/additional_images/gradient.png",
};
